import logo from "../assets/images/GSV-logo.png";

const Logo = () => {
  return <img src={logo} alt="Golf Swing Vision" className="logo" height={60}/>;
};

export default Logo;
